/* tslint:disable */
/* eslint-disable */
/**
 * Bikeleasing Accounts
 * Consumers of the API must follow the tolerant reader pattern. Especially the consumer    * must ignore unknown properties   * expect enumerations to be extended at any time (this includes discriminators)      These changes are considered backwards compatible.   However, we will never do a backwards-incompatible change without creating a new API version:   * removal of required properties   * removal of a supported request parameter   * adding a new required request parameter or attributes   * renaming of an attribute      All responses contain a common header `X-Request-Id` which identifies the individual HTTP request. This ID should be included in any bug reports or support requests.  There is a per-client rate limit on the API. If the rate limit is exceeded (resulting in a \"429 Too Many Requests\" response), please slow down and retry  after a short delay.  The API strives to return status codes that align with user expectations. However, in some error cases, multiple status codes may seem appropriate, and  the expected status code might not be clear. Here are two important points to consider when dealing with error status codes: 1. The API first checks the user\'s permission to access a resource. Only if the user has permission, it attempts to retrieve the resource. As a consequence, a user will     see a `403 Access Denied` status when requesting non-existent single resources since the permission check fails first. 2. There are no permissions on collections, only on the resources contained within them. Therefore, the API never returns a `403 Access Denied` status because the user     lacks permission to access a collection. Instead, the API returns a list containing all resources the user has permission to access. If the user has no permission to any     resource in the collection, an empty list with a `200 OK` status code is returned.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BulkCreateRegistrationCodesRequest } from '../dto';
// @ts-ignore
import type { BulkCreateRegistrationCodesResponse } from '../dto';
// @ts-ignore
import type { InlineObject } from '../dto';
// @ts-ignore
import type { InlineObject1 } from '../dto';
// @ts-ignore
import type { InlineObject2 } from '../dto';
// @ts-ignore
import type { RedeemRegistrationCodeRequest } from '../dto';
// @ts-ignore
import type { RedeemRegistrationCodeResponse } from '../dto';
// @ts-ignore
import type { RegistrationCode } from '../dto';
// @ts-ignore
import type { RegistrationCodeCreateRequest } from '../dto';
// @ts-ignore
import type { RegistrationCodesListResponse } from '../dto';
// @ts-ignore
import type { ValidateRegistrationCodeRequest } from '../dto';
// @ts-ignore
import type { ValidateRegistrationCodeResponse } from '../dto';
/**
 * RegistrationApi - axios parameter creator
 * @export
 */
export const RegistrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create multiple registration codes in a single request. This is useful for creating employee codes for multiple employees at once. Maximum 100 codes per request.
         * @summary Bulk create employee registration codes
         * @param {BulkCreateRegistrationCodesRequest} bulkCreateRegistrationCodesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateRegistrationCodes: async (bulkCreateRegistrationCodesRequest: BulkCreateRegistrationCodesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateRegistrationCodesRequest' is not null or undefined
            assertParamExists('bulkCreateRegistrationCodes', 'bulkCreateRegistrationCodesRequest', bulkCreateRegistrationCodesRequest)
            const localVarPath = `/api/v1/registration-codes/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateRegistrationCodesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new registration code for a company or an employee. Company codes can be reused multiple times, while employee codes are single use and unique to each employee.
         * @summary Create a new registration code
         * @param {RegistrationCodeCreateRequest} registrationCodeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistrationCode: async (registrationCodeCreateRequest: RegistrationCodeCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationCodeCreateRequest' is not null or undefined
            assertParamExists('createRegistrationCode', 'registrationCodeCreateRequest', registrationCodeCreateRequest)
            const localVarPath = `/api/v1/registration-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registrationCodeCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete (invalidate) a registration code by its ID. This operation marks the registration code as deleted and it can no longer be used for registration. Invalidated codes are kept for audit purposes.
         * @summary Delete (invalidate) a registration code
         * @param {string} id The ID of the registration code to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistrationCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRegistrationCode', 'id', id)
            const localVarPath = `/api/v1/registration-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:write"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve registration code details
         * @param {string} id The ID of the registration code to retrieve details for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationCode: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRegistrationCode', 'id', id)
            const localVarPath = `/api/v1/registration-codes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:read"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a list of registration codes with optional filtering by company ID, employee IDs, registration code, status, sorting, and pagination support. Either companyId, employeeIds, or registrationCode must be provided to filter the results.
         * @summary List existing registration codes
         * @param {string} [companyId] The ID of the company associated with the registration code.
         * @param {Array<string>} [employeeIds] The IDs of the employees associated with the registration code. Provide multiple values as repeated query parameters (e.g. ?employeeIds&#x3D;1&amp;employeeIds&#x3D;2).
         * @param {string} [registrationCode] The registration code to filter by.
         * @param {ListRegistrationCodesTypeEnum} [type] The type of the registration codes to filter by.
         * @param {ListRegistrationCodesStatusEnum} [status] The status of the registration codes to filter by.
         * @param {ListRegistrationCodesSortByEnum} [sortBy] The field to sort by. Defaults to createdAt for audit history purposes.
         * @param {ListRegistrationCodesSortOrderEnum} [sortOrder] The sort order. Defaults to desc (most recent first).
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] The maximum number of items to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistrationCodes: async (companyId?: string, employeeIds?: Array<string>, registrationCode?: string, type?: ListRegistrationCodesTypeEnum, status?: ListRegistrationCodesStatusEnum, sortBy?: ListRegistrationCodesSortByEnum, sortOrder?: ListRegistrationCodesSortOrderEnum, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/registration-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["companies:read"], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (employeeIds) {
                localVarQueryParameter['employeeIds'] = employeeIds;
            }

            if (registrationCode !== undefined) {
                localVarQueryParameter['registrationCode'] = registrationCode;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redeem a registration code to associate the authenticated user with a company. If the user is already registered with the company, the response will indicate this without making any changes.
         * @summary Redeem a registration code
         * @param {RedeemRegistrationCodeRequest} redeemRegistrationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemRegistrationCode: async (redeemRegistrationCodeRequest: RedeemRegistrationCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemRegistrationCodeRequest' is not null or undefined
            assertParamExists('redeemRegistrationCode', 'redeemRegistrationCodeRequest', redeemRegistrationCodeRequest)
            const localVarPath = `/api/v1/registration-codes/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:own-profile:write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemRegistrationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
         * @summary Validate a registration code
         * @param {ValidateRegistrationCodeRequest} validateRegistrationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRegistrationCode: async (validateRegistrationCodeRequest: ValidateRegistrationCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateRegistrationCodeRequest' is not null or undefined
            assertParamExists('validateRegistrationCode', 'validateRegistrationCodeRequest', validateRegistrationCodeRequest)
            const localVarPath = `/api/v1/public/registration-codes/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateRegistrationCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationApi - functional programming interface
 * @export
 */
export const RegistrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RegistrationApiAxiosParamCreator(configuration)
    return {
        /**
         * Create multiple registration codes in a single request. This is useful for creating employee codes for multiple employees at once. Maximum 100 codes per request.
         * @summary Bulk create employee registration codes
         * @param {BulkCreateRegistrationCodesRequest} bulkCreateRegistrationCodesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateRegistrationCodes(bulkCreateRegistrationCodesRequest: BulkCreateRegistrationCodesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateRegistrationCodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateRegistrationCodes(bulkCreateRegistrationCodesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.bulkCreateRegistrationCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new registration code for a company or an employee. Company codes can be reused multiple times, while employee codes are single use and unique to each employee.
         * @summary Create a new registration code
         * @param {RegistrationCodeCreateRequest} registrationCodeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRegistrationCode(registrationCodeCreateRequest: RegistrationCodeCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRegistrationCode(registrationCodeCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.createRegistrationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete (invalidate) a registration code by its ID. This operation marks the registration code as deleted and it can no longer be used for registration. Invalidated codes are kept for audit purposes.
         * @summary Delete (invalidate) a registration code
         * @param {string} id The ID of the registration code to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRegistrationCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRegistrationCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.deleteRegistrationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve registration code details
         * @param {string} id The ID of the registration code to retrieve details for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegistrationCode(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegistrationCode(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.getRegistrationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a list of registration codes with optional filtering by company ID, employee IDs, registration code, status, sorting, and pagination support. Either companyId, employeeIds, or registrationCode must be provided to filter the results.
         * @summary List existing registration codes
         * @param {string} [companyId] The ID of the company associated with the registration code.
         * @param {Array<string>} [employeeIds] The IDs of the employees associated with the registration code. Provide multiple values as repeated query parameters (e.g. ?employeeIds&#x3D;1&amp;employeeIds&#x3D;2).
         * @param {string} [registrationCode] The registration code to filter by.
         * @param {ListRegistrationCodesTypeEnum} [type] The type of the registration codes to filter by.
         * @param {ListRegistrationCodesStatusEnum} [status] The status of the registration codes to filter by.
         * @param {ListRegistrationCodesSortByEnum} [sortBy] The field to sort by. Defaults to createdAt for audit history purposes.
         * @param {ListRegistrationCodesSortOrderEnum} [sortOrder] The sort order. Defaults to desc (most recent first).
         * @param {number} [offset] The number of items to skip before starting to collect the result set.
         * @param {number} [limit] The maximum number of items to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRegistrationCodes(companyId?: string, employeeIds?: Array<string>, registrationCode?: string, type?: ListRegistrationCodesTypeEnum, status?: ListRegistrationCodesStatusEnum, sortBy?: ListRegistrationCodesSortByEnum, sortOrder?: ListRegistrationCodesSortOrderEnum, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegistrationCodesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRegistrationCodes(companyId, employeeIds, registrationCode, type, status, sortBy, sortOrder, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.listRegistrationCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redeem a registration code to associate the authenticated user with a company. If the user is already registered with the company, the response will indicate this without making any changes.
         * @summary Redeem a registration code
         * @param {RedeemRegistrationCodeRequest} redeemRegistrationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemRegistrationCode(redeemRegistrationCodeRequest: RedeemRegistrationCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedeemRegistrationCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemRegistrationCode(redeemRegistrationCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.redeemRegistrationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
         * @summary Validate a registration code
         * @param {ValidateRegistrationCodeRequest} validateRegistrationCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateRegistrationCode(validateRegistrationCodeRequest: ValidateRegistrationCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateRegistrationCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateRegistrationCode(validateRegistrationCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RegistrationApi.validateRegistrationCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RegistrationApi - factory interface
 * @export
 */
export const RegistrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RegistrationApiFp(configuration)
    return {
        /**
         * Create multiple registration codes in a single request. This is useful for creating employee codes for multiple employees at once. Maximum 100 codes per request.
         * @summary Bulk create employee registration codes
         * @param {RegistrationApiBulkCreateRegistrationCodesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateRegistrationCodes(requestParameters: RegistrationApiBulkCreateRegistrationCodesRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkCreateRegistrationCodesResponse> {
            return localVarFp.bulkCreateRegistrationCodes(requestParameters.bulkCreateRegistrationCodesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new registration code for a company or an employee. Company codes can be reused multiple times, while employee codes are single use and unique to each employee.
         * @summary Create a new registration code
         * @param {RegistrationApiCreateRegistrationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRegistrationCode(requestParameters: RegistrationApiCreateRegistrationCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegistrationCode> {
            return localVarFp.createRegistrationCode(requestParameters.registrationCodeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete (invalidate) a registration code by its ID. This operation marks the registration code as deleted and it can no longer be used for registration. Invalidated codes are kept for audit purposes.
         * @summary Delete (invalidate) a registration code
         * @param {RegistrationApiDeleteRegistrationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRegistrationCode(requestParameters: RegistrationApiDeleteRegistrationCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRegistrationCode(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve registration code details
         * @param {RegistrationApiGetRegistrationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegistrationCode(requestParameters: RegistrationApiGetRegistrationCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<RegistrationCode> {
            return localVarFp.getRegistrationCode(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of registration codes with optional filtering by company ID, employee IDs, registration code, status, sorting, and pagination support. Either companyId, employeeIds, or registrationCode must be provided to filter the results.
         * @summary List existing registration codes
         * @param {RegistrationApiListRegistrationCodesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistrationCodes(requestParameters: RegistrationApiListRegistrationCodesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<RegistrationCodesListResponse> {
            return localVarFp.listRegistrationCodes(requestParameters.companyId, requestParameters.employeeIds, requestParameters.registrationCode, requestParameters.type, requestParameters.status, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.offset, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Redeem a registration code to associate the authenticated user with a company. If the user is already registered with the company, the response will indicate this without making any changes.
         * @summary Redeem a registration code
         * @param {RegistrationApiRedeemRegistrationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemRegistrationCode(requestParameters: RegistrationApiRedeemRegistrationCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<RedeemRegistrationCodeResponse> {
            return localVarFp.redeemRegistrationCode(requestParameters.redeemRegistrationCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
         * @summary Validate a registration code
         * @param {RegistrationApiValidateRegistrationCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRegistrationCode(requestParameters: RegistrationApiValidateRegistrationCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ValidateRegistrationCodeResponse> {
            return localVarFp.validateRegistrationCode(requestParameters.validateRegistrationCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkCreateRegistrationCodes operation in RegistrationApi.
 * @export
 * @interface RegistrationApiBulkCreateRegistrationCodesRequest
 */
export interface RegistrationApiBulkCreateRegistrationCodesRequest {
    /**
     * 
     * @type {BulkCreateRegistrationCodesRequest}
     * @memberof RegistrationApiBulkCreateRegistrationCodes
     */
    readonly bulkCreateRegistrationCodesRequest: BulkCreateRegistrationCodesRequest
}

/**
 * Request parameters for createRegistrationCode operation in RegistrationApi.
 * @export
 * @interface RegistrationApiCreateRegistrationCodeRequest
 */
export interface RegistrationApiCreateRegistrationCodeRequest {
    /**
     * 
     * @type {RegistrationCodeCreateRequest}
     * @memberof RegistrationApiCreateRegistrationCode
     */
    readonly registrationCodeCreateRequest: RegistrationCodeCreateRequest
}

/**
 * Request parameters for deleteRegistrationCode operation in RegistrationApi.
 * @export
 * @interface RegistrationApiDeleteRegistrationCodeRequest
 */
export interface RegistrationApiDeleteRegistrationCodeRequest {
    /**
     * The ID of the registration code to be deleted.
     * @type {string}
     * @memberof RegistrationApiDeleteRegistrationCode
     */
    readonly id: string
}

/**
 * Request parameters for getRegistrationCode operation in RegistrationApi.
 * @export
 * @interface RegistrationApiGetRegistrationCodeRequest
 */
export interface RegistrationApiGetRegistrationCodeRequest {
    /**
     * The ID of the registration code to retrieve details for.
     * @type {string}
     * @memberof RegistrationApiGetRegistrationCode
     */
    readonly id: string
}

/**
 * Request parameters for listRegistrationCodes operation in RegistrationApi.
 * @export
 * @interface RegistrationApiListRegistrationCodesRequest
 */
export interface RegistrationApiListRegistrationCodesRequest {
    /**
     * The ID of the company associated with the registration code.
     * @type {string}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly companyId?: string

    /**
     * The IDs of the employees associated with the registration code. Provide multiple values as repeated query parameters (e.g. ?employeeIds&#x3D;1&amp;employeeIds&#x3D;2).
     * @type {Array<string>}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly employeeIds?: Array<string>

    /**
     * The registration code to filter by.
     * @type {string}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly registrationCode?: string

    /**
     * The type of the registration codes to filter by.
     * @type {'EMPLOYEE' | 'COMPANY'}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly type?: ListRegistrationCodesTypeEnum

    /**
     * The status of the registration codes to filter by.
     * @type {'ACTIVE' | 'REDEEMED' | 'EXPIRED'}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly status?: ListRegistrationCodesStatusEnum

    /**
     * The field to sort by. Defaults to createdAt for audit history purposes.
     * @type {'createdAt' | 'redeemedAt' | 'expirationDate' | 'status'}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly sortBy?: ListRegistrationCodesSortByEnum

    /**
     * The sort order. Defaults to desc (most recent first).
     * @type {'asc' | 'desc'}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly sortOrder?: ListRegistrationCodesSortOrderEnum

    /**
     * The number of items to skip before starting to collect the result set.
     * @type {number}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly offset?: number

    /**
     * The maximum number of items to return.
     * @type {number}
     * @memberof RegistrationApiListRegistrationCodes
     */
    readonly limit?: number
}

/**
 * Request parameters for redeemRegistrationCode operation in RegistrationApi.
 * @export
 * @interface RegistrationApiRedeemRegistrationCodeRequest
 */
export interface RegistrationApiRedeemRegistrationCodeRequest {
    /**
     * 
     * @type {RedeemRegistrationCodeRequest}
     * @memberof RegistrationApiRedeemRegistrationCode
     */
    readonly redeemRegistrationCodeRequest: RedeemRegistrationCodeRequest
}

/**
 * Request parameters for validateRegistrationCode operation in RegistrationApi.
 * @export
 * @interface RegistrationApiValidateRegistrationCodeRequest
 */
export interface RegistrationApiValidateRegistrationCodeRequest {
    /**
     * 
     * @type {ValidateRegistrationCodeRequest}
     * @memberof RegistrationApiValidateRegistrationCode
     */
    readonly validateRegistrationCodeRequest: ValidateRegistrationCodeRequest
}

/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
export class RegistrationApi extends BaseAPI {
    /**
     * Create multiple registration codes in a single request. This is useful for creating employee codes for multiple employees at once. Maximum 100 codes per request.
     * @summary Bulk create employee registration codes
     * @param {RegistrationApiBulkCreateRegistrationCodesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public bulkCreateRegistrationCodes(requestParameters: RegistrationApiBulkCreateRegistrationCodesRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).bulkCreateRegistrationCodes(requestParameters.bulkCreateRegistrationCodesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new registration code for a company or an employee. Company codes can be reused multiple times, while employee codes are single use and unique to each employee.
     * @summary Create a new registration code
     * @param {RegistrationApiCreateRegistrationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public createRegistrationCode(requestParameters: RegistrationApiCreateRegistrationCodeRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).createRegistrationCode(requestParameters.registrationCodeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete (invalidate) a registration code by its ID. This operation marks the registration code as deleted and it can no longer be used for registration. Invalidated codes are kept for audit purposes.
     * @summary Delete (invalidate) a registration code
     * @param {RegistrationApiDeleteRegistrationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public deleteRegistrationCode(requestParameters: RegistrationApiDeleteRegistrationCodeRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).deleteRegistrationCode(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve registration code details
     * @param {RegistrationApiGetRegistrationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public getRegistrationCode(requestParameters: RegistrationApiGetRegistrationCodeRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).getRegistrationCode(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a list of registration codes with optional filtering by company ID, employee IDs, registration code, status, sorting, and pagination support. Either companyId, employeeIds, or registrationCode must be provided to filter the results.
     * @summary List existing registration codes
     * @param {RegistrationApiListRegistrationCodesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public listRegistrationCodes(requestParameters: RegistrationApiListRegistrationCodesRequest = {}, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).listRegistrationCodes(requestParameters.companyId, requestParameters.employeeIds, requestParameters.registrationCode, requestParameters.type, requestParameters.status, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.offset, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redeem a registration code to associate the authenticated user with a company. If the user is already registered with the company, the response will indicate this without making any changes.
     * @summary Redeem a registration code
     * @param {RegistrationApiRedeemRegistrationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public redeemRegistrationCode(requestParameters: RegistrationApiRedeemRegistrationCodeRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).redeemRegistrationCode(requestParameters.redeemRegistrationCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate a registration code without redeeming it, and retrieve information about the associated company. This endpoint is publicly accessible and does not require authentication. Call this before registration, so the user knows which company they are registering with.
     * @summary Validate a registration code
     * @param {RegistrationApiValidateRegistrationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    public validateRegistrationCode(requestParameters: RegistrationApiValidateRegistrationCodeRequest, options?: RawAxiosRequestConfig) {
        return RegistrationApiFp(this.configuration).validateRegistrationCode(requestParameters.validateRegistrationCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListRegistrationCodesTypeEnum = {
    Employee: 'EMPLOYEE',
    Company: 'COMPANY'
} as const;
export type ListRegistrationCodesTypeEnum = typeof ListRegistrationCodesTypeEnum[keyof typeof ListRegistrationCodesTypeEnum];
/**
 * @export
 */
export const ListRegistrationCodesStatusEnum = {
    Active: 'ACTIVE',
    Redeemed: 'REDEEMED',
    Expired: 'EXPIRED'
} as const;
export type ListRegistrationCodesStatusEnum = typeof ListRegistrationCodesStatusEnum[keyof typeof ListRegistrationCodesStatusEnum];
/**
 * @export
 */
export const ListRegistrationCodesSortByEnum = {
    CreatedAt: 'createdAt',
    RedeemedAt: 'redeemedAt',
    ExpirationDate: 'expirationDate',
    Status: 'status'
} as const;
export type ListRegistrationCodesSortByEnum = typeof ListRegistrationCodesSortByEnum[keyof typeof ListRegistrationCodesSortByEnum];
/**
 * @export
 */
export const ListRegistrationCodesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListRegistrationCodesSortOrderEnum = typeof ListRegistrationCodesSortOrderEnum[keyof typeof ListRegistrationCodesSortOrderEnum];
